exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir=ltr] .eOKBgRu0UC2dRzJQZ32Rr{padding-right:10px}html[dir=rtl] .eOKBgRu0UC2dRzJQZ32Rr{padding-left:10px}._3l6Y1hJssQoCq2rtcYHJIz{height:20px}html[dir] ._3l6Y1hJssQoCq2rtcYHJIz{margin:5px 0}html[dir=ltr] ._2DS08L_ggX6LF5IWbmuwOF{padding-left:10px}html[dir=rtl] ._2DS08L_ggX6LF5IWbmuwOF{padding-right:10px}html[dir=ltr] ._2IHSvwhh4hkzOWobahW1nM{padding-left:10px}html[dir=rtl] ._2IHSvwhh4hkzOWobahW1nM{padding-right:10px}", ""]);

// exports
exports.locals = {
	"HelpIcon": "eOKBgRu0UC2dRzJQZ32Rr",
	"RibbonMessage": "_3l6Y1hJssQoCq2rtcYHJIz",
	"YesLink": "_2DS08L_ggX6LF5IWbmuwOF",
	"NoLink": "_2IHSvwhh4hkzOWobahW1nM"
};